export default "__VITE_ASSET__BLVyypk5__"